import { Box, Text } from 'ink';
import { ComponentProps } from 'react';

export default function CustomSelectInputIndicator({
  isSelected,
  ...props
}: {
  isSelected?: boolean;
} & ComponentProps<typeof Box>) {
  const selectIndicator =
    process.env.NODE_ENV === 'test' || process.platform === 'win32' ? '>' : '❯';

  return (
    <Box marginRight={1} {...props}>
      <Text>{isSelected ? selectIndicator : ' '}</Text>
    </Box>
  );
}
